// src/hooks/useAuth.ts
import { useAuthContext } from "./AuthContext";

export function useAuth() {
  return useAuthContext();
}